export const iconFontAwesomeEditingPenFancy = (
	<i className="fa-solid fa-pen-fancy"></i>
);
